class SaleCountdown {
  constructor(options) {
    this.options = options || {};
    this.daysElement = document.querySelector("#sale-countdown-days");
    this.hoursElement = document.querySelector("#sale-countdown-hours");
    this.minutesElement = document.querySelector("#sale-countdown-minutes");
    this.secondsElement = document.querySelector("#sale-countdown-seconds");
    this.lastValues = {};
    this.initLabels();
    this.computeTarget();
    this.updateCountdown();
    setInterval(() => this.updateCountdown(), 1000);
  }

  initLabels() {
    const labels = [
      ["#days-label", this.options.showDays ? this.options.daysLabel : null],
      ["#hours-label", this.options.hoursLabel],
      ["#minutes-label", this.options.minutesLabel],
      ["#seconds-label", this.options.secondsLabel],
    ];
    labels.forEach(([selector, value]) => {
      if (value == null) return;
      const element = document.querySelector(selector);
      if (element) element.textContent = value;
    });
  }

  computeTarget() {
    if (this.options.customEndTime) {
      this.target = new Date(
        this.options.endYear,
        this.options.endMonth - 1,
        this.options.endDay,
        this.options.endHour,
        this.options.endMinute,
        0
      ).getTime();
      this.repeating = false;
      return;
    }
    // Next midnight EST/EDT (04:00/05:00 UTC), DST probed once per target
    const now = new Date();
    const jan = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
    const jul = new Date(now.getFullYear(), 6, 1).getTimezoneOffset();
    const isDST = Math.max(jan, jul) !== now.getTimezoneOffset();
    const estMidnight = new Date();
    estMidnight.setUTCHours(isDST ? 4 : 5, 0, 0, 0);
    if (estMidnight.getTime() <= now.getTime()) {
      estMidnight.setUTCDate(estMidnight.getUTCDate() + 1);
    }
    this.target = estMidnight.getTime();
    this.repeating = true;
  }

  updateCountdown() {
    let timeDifference = this.target - Date.now();
    if (timeDifference <= 0) {
      if (this.repeating) {
        this.computeTarget();
        timeDifference = this.target - Date.now();
      } else {
        this.setZeroValues();
        return;
      }
    }
    const days = Math.floor(timeDifference / 86400000);
    const hours = Math.floor((timeDifference % 86400000) / 3600000);
    const minutes = Math.floor((timeDifference % 3600000) / 60000);
    const seconds = Math.floor((timeDifference % 60000) / 1000);
    this.displayTimeValues(days, hours, minutes, seconds);
  }

  setZeroValues() {
    const zero = this.options.zeroValue;
    this.displayRaw("days", this.options.showDays ? zero : null);
    this.displayRaw("hours", zero);
    this.displayRaw("minutes", zero);
    this.displayRaw("seconds", zero);
  }

  displayTimeValues(days, hours, minutes, seconds) {
    const format = (num) =>
      num < 10 ? this.options.timeFormatSingleDigit + num : num.toString();
    this.displayRaw("days", this.options.showDays ? format(days) : null);
    this.displayRaw("hours", format(hours));
    this.displayRaw("minutes", format(minutes));
    this.displayRaw("seconds", format(seconds));
  }

  displayRaw(unit, value) {
    if (value == null || this.lastValues[unit] === value) return;
    const element = this[unit + "Element"];
    if (element) {
      element.textContent = value;
      this.lastValues[unit] = value;
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new SaleCountdown(window.saleCountdownOptions || {});
});
